<!--
零件类型说明
20220331
-->
<template>
  <van-popup
    v-model="showSubplateBricktypeInfo"
    position="bottom"
    class="subplate_bricktype_info"
  >
    <div class="subplate_box">

      <div class="bricktype_title">零件类型说明</div>
      <div class="releasedtips">
        符合规格的积木零件可以在其体系内互相组合。我们以“乐高 LEGO SYSTEM”小颗粒为标准，根据积木类产品的兼容情况做出以下区分。
        <br><br>
        不同的兼容体系适用于各自的玩乐场景，并无优劣之分。
        <br><br>
        （注意：这只是一个粗略分类，并且我们的资料可能也有偏差，所以仅可作为参考。）
      </div>

      <div class="list_selectbricktype">
        
        <div class="item_selectbricktype">
          <div class="item_selectbricktype_box">
            <div class="selectbricktype_icon"></div>
            <div class="item_selectbricktype_text">
              <div class="title"><b>小颗粒</b><span>8毫米</span></div>
              <div class="text">常规的“乐高”标准颗粒。通常我们不会为这种规格做特殊说明。</div>
            </div>
          </div>
        </div>
        
        <div class="item_selectbricktype">
          <div class="item_selectbricktype_box">
            <div class="selectbricktype_icon icon_2"></div>
            <div class="item_selectbricktype_text">
              <div class="title"><b>大颗粒</b><span>16毫米</span></div>
              <div class="text">适合学龄前儿童抓握拼插的大颗粒积木。为了避免吞咽，通常没有可拆解的小零件。例：乐高得宝 Duplo 等</div>
            </div>
          </div>
        </div>
        
        <div class="item_selectbricktype">
          <div class="item_selectbricktype_box">
            <div class="selectbricktype_icon icon_4"></div>
            <div class="item_selectbricktype_text">
              <div class="title"><b>迷你颗粒</b><span>6毫米</span></div>
              <div class="text">MINI颗粒，是标准小颗粒的等比例缩小版，适用于成年人。优点是成品体积更小，更加精致。缺点是不易拾取拼插，零件种类有限。例：Lin07</div>
            </div>
          </div>
        </div>
        
        <div class="item_selectbricktype">
          <div class="item_selectbricktype_box">
            <div class="selectbricktype_icon icon_3"></div>
            <div class="item_selectbricktype_text">
              <div class="title"><b>微钻颗粒</b><span>4毫米</span></div>
              <div class="text">钻石颗粒，体积是标准小颗粒的1/8。零件种类不多，成品多为立体雕塑。例：Nano block、LOZ、lezi、贝乐迪、智鹰等</div>
            </div>
          </div>
        </div>
        
        <div class="item_selectbricktype">
          <div class="item_selectbricktype_box">
            <div class="selectbricktype_icon icon_6"></div>
            <div class="item_selectbricktype_text">
              <div class="title"><b>巨型积木</b><span></span></div>
              <div class="text">EPP泡沫积木，适用于游乐场</div>
            </div>
          </div>
        </div>
        
        
        <div class="item_selectbricktype">
          <div class="item_selectbricktype_box">
            <div class="selectbricktype_icon icon_6"></div>
            <div class="item_selectbricktype_text">
              <div class="title"><b>特殊规格</b><span></span></div>
              <div class="text">自成体系。例：布鲁可、邦宝等</div>
            </div>
          </div>
        </div>


      </div>





    </div>

    <div class="bottombar">
      <div class="bottombar_box">
        <div class="bottombar_part">
          <a class="btn_inner btn btn_shadow btn_color_4 btn_cancel btn_round" @click="showSubplateBricktypeInfo=false">
            <span>关闭</span>
          </a>
        </div>
      </div>
    </div>

  </van-popup>
</template>

<script>

export default {
  name: 'BricktypeInfo',
  components: {},
  props: {

  },
  data () {
    return {
      showSubplateBricktypeInfo: false,
    }
  },
  computed: {

  },
  watch: {},
  created() {
    const _this = this;

  },
  mounted() {

  },
  destroyed() {},
  methods: {

    //关闭面板
    hideSubplateBricktypeInfo(hide=true){
      const _this = this;
      _this.showSubplateBricktypeInfo = !hide;
    },

  }
}
</script>



<style lang="less">

@bluecolor: #4E66FF;


</style>


<style lang="less" scoped>
@bluecolor: #4E66FF;

.subplate_bricktype_info {
  top: 80px;
  .subplate_box {
    padding: 30px 30px 60px;
    
    position: relative;

    .bricktype_title {
      font-size: 20px;
      font-weight: bold;
      color: #858585;
      margin-bottom: 10px;
    }

    .releasedtips {
      margin-bottom: 20px;
    }

    .list_selectbricktype {
      background-color: #fff;
      .item_selectbricktype {
        padding: 10px;
        min-width: 115px;
        border-radius: 4px;
        border-bottom: 2px solid #f8f8f8;
        position: relative;
        .item_selectbricktype_box {
          display: flex;
          align-items: start;
          .selectbricktype_icon {
            width: 80px;
            height: 80px;
            background-image: url(/static/img/bricktype_icon.png);
            background-position: left;
            background-repeat: no-repeat;
            background-size: auto 100%;
            margin-right: 5px;
            flex-shrink: 0;
            &.icon_2 {
              background-position: 20%;
            }
            &.icon_3 {
              background-position: 40%;
            }
            &.icon_4 {
              background-position: 60%;
            }
            &.icon_5 {
              background-position: 80%;
            }
            &.icon_6 {
              background-position: 100%;
            }
          }
          .item_selectbricktype_text {
            flex: 1;
            .title {
              b {
                padding-right: 10px;
                font-size: 15px;
              }
              span {
                opacity: .6;
              }
            }
          }
        }
      }
    }





  }


  

}
</style>


// WEBPACK FOOTER //
// src/views/set/BricktypeInfo.vue